export const formatDropdownOptions = (
  option: any[],
): { value: any; label: any }[] => {
  return option?.map((opt) => ({
    value: opt,
    label: opt,
  }));
};

export const timezone = [
  { id: 0, name: "IST", fullName: "Asia/Calcutta" },
  { id: 1, name: "EST", fullName: "America/New_York" },
  { id: 2, name: "GMT", fullName: "Europe/London" },
  { id: 3, name: "CST", fullName: "America/Chicago" },
  { id: 4, name: "PST", fullName: "America/Los_Angeles" },
  { id: 5, name: "HST", fullName: "Pacific/Honolulu" },
  { id: 6, name: "AHST", fullName: "America/Anchorage" },
];

export const sevenDaysAgo = (() => {
  const d = new Date();
  d.setDate(d.getDate() - 7);
  return d;
})();
export const NextSevenDays = (() => {
  const d = new Date();
  d.setDate(d.getDate() + 7);
  return d;
})();
